
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 7 12"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#455065","stroke-linecap":"round","d":"M7 11L1.467 6.525a.5.5 0 0 1-.011-.769L7 1"}})])
          )
        }
      }
    